// @flow
import React from 'react'

const Sofa = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="23" height="19" viewBox="0 0 23 19">
      <g fill="none" fillRule="evenodd" stroke="#6E7B8C" strokeLinecap="square">
        <path d="M2.5 18.5v-2M20.5 18.5v-2M22.5 16.5v-9h-4v4h-14v-4h-4v9zM2.5 7.5v-7h18v7M11.5 11.5V.5" />
      </g>
    </svg>
  )
}

export default Sofa



// WEBPACK FOOTER //
// ./src/components/Icons/Sofa.js